import React, { ReactElement, useContext } from 'react'
import { Link } from 'react-router-dom'
import { Flexbox } from '../flexbox/flexbox'
import { AppNavigationGroupContext } from './app-navigation-group-context'
import classNames from 'classnames'
import { useLocation } from 'react-router'

interface Props {
  readonly title: string
  readonly to: string
  readonly icon?: ReactElement[] | ReactElement
  readonly onPress?: () => void
  readonly isExactPath?: boolean
}

const AppNavigationItem = (props: Props): ReactElement => {
  const { to, title, icon, onPress, isExactPath } = props

  const location = useLocation().pathname
  const isActive = isExactPath ? location === to : location.startsWith(to)
  const isInGroup = !!useContext(AppNavigationGroupContext)

  return (
    <Link
      to={to}
      onClick={onPress}
      className={classNames({
        flex: 1,
        'bg-base-200': isActive,
        'p-1': isInGroup,
      })}>
      <Flexbox
        alignItems="center"
        className={classNames({
          'ml-10': isInGroup,
        })}>
        {icon && <div className="p-2">{icon}</div>}
        <div
          className={classNames({
            'font-medium': !isInGroup,
            'opacity-75': isInGroup,
          })}>
          {title}
        </div>
      </Flexbox>
    </Link>
  )
}

export default React.memo(AppNavigationItem)